import { createContext, useContext, useLayoutEffect } from 'react';

/**
 * Lets a guest page widen the 540px guest column while it is mounted. Only pages that need a second
 * column ask for it, so every other guest page keeps its current width.
 */
export const ShellWidthContext = createContext<(wide: boolean) => void>(() => {});

export function useWideShell() {
  const setWide = useContext(ShellWidthContext);
  // Before paint, so the page never flashes in the narrow column.
  useLayoutEffect(() => {
    setWide(true);
    return () => setWide(false);
  }, [setWide]);
}

/**
 * Lets a booking page (PLA-1710: booking pages, their checkout and the cart page) pin the shell to
 * the PlayerUp design system's dark theme while it is mounted, whatever the reader's light or dark
 * preference. Other guest pages keep following it.
 */
export const ShellThemeContext = createContext<(booking: boolean) => void>(() => {});

export function useBookingTheme() {
  const setBooking = useContext(ShellThemeContext);
  // Before paint, so the page never flashes in the light theme.
  useLayoutEffect(() => {
    setBooking(true);
    return () => setBooking(false);
  }, [setBooking]);
}
